import { findIndex, kebabCase } from 'lodash'

import factory from './factory'
import { getClientId } from '@/utils/client'

export default {
  hasBankFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.bankField)
  },
  hasCategoryFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.categoryField)
  },
  hasCountryFilter (state) {
    return state.appliedFilters.hasOwnProperty(factory.countryField)
  },
  hasFilters (state) {
    return Object.keys(state.appliedFilters).length > 0
  },
  previousId (state) {
    return idOrSlug => {
      const id = getClientId(state.ordered, idOrSlug)
      const index = findIndex(state.ordered, { id }) - 1
      return state.ordered[index] ? kebabCase(state.ordered[index].long_name) : null
    }
  },
  nextId (state) {
    return idOrSlug => {
      const id = getClientId(state.ordered, idOrSlug)
      const index = findIndex(state.ordered, { id }) + 1
      return state.ordered[index] ? kebabCase(state.ordered[index].long_name) : null
    }
  }
}
